import { useCallback } from 'react';
import { useAngularContext } from 'AngularContext';
import { type AnyObject } from '@Types';
import { type StreamForStreamDashboard } from 'Lessons';
import { useSiteMetadata } from 'SearchEngineOptimization/useSiteMetadata';
import { type ShareProvider } from '../StreamDashboard.types';
import { getStreamLogInfo } from '../selectors';
import { toStreamForShareInfo } from '../toStreamForDashboard';

// ShareService and SiteMetadata stay in Angular. contentDefaultShareInfo needs the Iguana user from $rootScope.
export function useShareStream(stream: StreamForStreamDashboard) {
    const $injector = useAngularContext();
    const SiteMetadata = useSiteMetadata();

    return useCallback(
        (provider: ShareProvider) => {
            const $rootScope = $injector.get<AnyObject>('$rootScope');
            const ShareService = $injector.get<AnyObject<(...args: unknown[]) => void>>('Navigation.ShareService');

            ShareService.share(
                'stream',
                provider,
                SiteMetadata.contentDefaultShareInfo($rootScope.currentUser, toStreamForShareInfo(stream)),
                getStreamLogInfo(stream),
            );
        },
        [stream, $injector, SiteMetadata],
    );
}
